'use client'
import { ContactUsForm } from '@/components'
import { useRouter } from 'next/navigation'
import React, { useState, useEffect, useRef } from 'react'

function NewsRoomPage() {
   const [newsData, setNewsData] = useState([])
   const [currentPage, setCurrentPage] = useState(1)
   const [totalCount, setTotalCount] = useState(0)
   const [loading, setLoading] = useState(false)
   const [initialLoading, setInitialLoading] = useState(true)
   const router = useRouter()
   const [category, setCategory] = useState([])
   const [selectedCategory, setSelectedCategory] = useState('')
   const [categoryLoading, setCategoryLoading] = useState(true)
   const [showDropdown, setShowDropdown] = useState(false)
   const categoryContainerRef = useRef(null)
   const dropdownRef = useRef(null)

   useEffect(() => {
      function handleClickOutside(event) {
         if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target)
         ) {
            setShowDropdown(false)
         }
      }

      if (showDropdown) {
         document.addEventListener('mousedown', handleClickOutside)
      }

      return () => {
         document.removeEventListener('mousedown', handleClickOutside)
      }
   }, [showDropdown])

   useEffect(() => {
      let dd = localStorage.getItem('news-cat')
      if (dd) {
         setSelectedCategory(dd)
         fetchNews(dd, 1)
      } else {
         fetchNews('', 1)
         setSelectedCategory('')
      }
   }, [])

   const fetchNews = async (type = '', page = 1) => {
      try {
         setLoading(true)
         if (page === 1) {
            setNewsData([])
         }
         const response = await fetch(
            `${process.env.NEXT_PUBLIC_NEWS_ROOM_BACKEND_URL}/news/?page=${page}&category=${type}`
         )
         const data = await response.json()
         const updatedNews =
            page === 1
               ? data.results
               : [
                    ...newsData,
                    ...data.results.filter(
                       (item) =>
                          !newsData.some((existing) => existing.id === item.id)
                    ),
                 ]
         setNewsData(updatedNews)
         setTotalCount(data.count)
      } catch (error) {
         console.error('Error fetching news:', error)
      } finally {
         setLoading(false)
         setInitialLoading(false)
         localStorage.removeItem('news-cat')
      }
   }

   // useEffect(() => {
   //    fetchNews('', 1)
   // }, [])

   const getCategoryNews = async () => {
      try {
         setCategoryLoading(true)
         const response = await fetch(
            `${process.env.NEXT_PUBLIC_NEWS_ROOM_BACKEND_URL}/news/types/`
         )
         const data = await response.json()
         setCategory(data.data)
      } catch (error) {
         setCategory([])
         console.error('Error fetching news:', error)
      } finally {
         setCategoryLoading(false)
      }
   }

   useEffect(() => {
      getCategoryNews()
   }, [])

   const toggleDropdown = () => setShowDropdown(!showDropdown)

   const visibleCategories = category.slice(0, 6)
   const overflowCategories = category.slice(6)

   const onRedirect = (slug) => {
      router.push(`/news-room/${slug}`)
   }

   const handleLoadMore = () => {
      if (loading) return
      const nextPage = currentPage + 1
      setCurrentPage(nextPage)
      fetchNews(selectedCategory, nextPage)
   }

   const renderSkeletonLoader = () => {
      return Array(3)
         .fill(null)
         .map((_, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-4 col-xxl-3">
               <div className="news-card-wrap skeleton-card">
                  <div className="news-image-wrap skeleton-image" />
                  <div className="news-content-wrap">
                     <div className="skeleton-title" />
                     <div className="skeleton-source" />
                  </div>
               </div>
            </div>
         ))
   }

   const chunkedNews = []
   for (let i = 0; i < newsData.length; i += 10) {
      chunkedNews.push(newsData.slice(i, i + 10))
   }

   return (
      <>
         <section className="section_theme_2_bg first-section news-card-section">
            <div className="news-container">
               {!categoryLoading && (
                  <div className="news-cat-section" ref={categoryContainerRef}>
                     <div
                        className={`news-cat-wrap ${
                           selectedCategory === '' ? 'active' : ''
                        }`}
                        onClick={() => {
                           setSelectedCategory('')
                           fetchNews('', 1)
                           setCurrentPage(1)
                           setNewsData([])
                        }}
                     >
                        <span>All</span>
                     </div>
                     {visibleCategories.map((item, i) => (
                        <div
                           className={`news-cat-wrap ${
                              selectedCategory === item ? 'active' : ''
                           }`}
                           key={i}
                           onClick={() => {
                              setSelectedCategory(item)
                              fetchNews(item, 1)
                              setCurrentPage(1)
                              setNewsData([])
                           }}
                        >
                           <span>{item}</span>
                        </div>
                     ))}
                     {overflowCategories.length > 0 && (
                        <div className="news-cat-wrap" ref={dropdownRef}>
                           <div className="dropdown">
                              <div
                                 onClick={toggleDropdown}
                                 className="dropdown-toggle"
                              >
                                 More
                              </div>
                              {showDropdown && (
                                 <div className="dropdown-menu news-more-opt show">
                                    {overflowCategories.map((item, i) => (
                                       <div
                                          key={i}
                                          className={`dropdown-item ${
                                             selectedCategory === item
                                                ? 'active'
                                                : ''
                                          }`}
                                          onClick={() => {
                                             setSelectedCategory(item)
                                             fetchNews(item, 1)
                                             setCurrentPage(1)
                                             setShowDropdown(false)
                                             setNewsData([])
                                          }}
                                       >
                                          {item}
                                       </div>
                                    ))}
                                 </div>
                              )}
                           </div>
                        </div>
                     )}
                  </div>
               )}
               {/* {!initialLoading && chunkedNews.length === 0 && (
                  <div className="text-center py-5">
                     <h3>No news articles available right now</h3>
                     <p>Check back later or refresh the page.</p>
                  </div>
               )} */}

               {chunkedNews.map((pageItems, pageIndex) => {
                  const isReversed = pageIndex % 2 !== 0

                  return (
                     <React.Fragment key={pageIndex}>
                        {/* First Row */}
                        <div className="row mb-4 first-row">
                           {isReversed ? (
                              <>
                                 <div className="col-md-7">
                                    <div className="grid-2x2">
                                       {pageItems
                                          .slice(1, 5)
                                          .map((card, idx) => (
                                             <NewsCard
                                                key={`first-row-right-${pageIndex}-${idx}`}
                                                card={card}
                                                onRedirect={onRedirect}
                                             />
                                          ))}
                                    </div>
                                 </div>
                                 <div className="col-md-5">
                                    {pageItems[0] && (
                                       <NewsCard
                                          card={pageItems[0]}
                                          large
                                          onRedirect={onRedirect}
                                       />
                                    )}
                                 </div>
                              </>
                           ) : (
                              <>
                                 <div className="col-md-5">
                                    {pageItems[0] && (
                                       <NewsCard
                                          card={pageItems[0]}
                                          large
                                          onRedirect={onRedirect}
                                       />
                                    )}
                                 </div>
                                 <div className="col-md-7">
                                    <div className="grid-2x2">
                                       {pageItems
                                          .slice(1, 5)
                                          .map((card, idx) => (
                                             <NewsCard
                                                key={`first-row-right-${pageIndex}-${idx}`}
                                                card={card}
                                                onRedirect={onRedirect}
                                             />
                                          ))}
                                    </div>
                                 </div>
                              </>
                           )}
                        </div>

                        {/* Second Row (reversible) */}
                        <div className="row mb-4 second-row">
                           {isReversed ? (
                              <>
                                 <div className="col-md-8">
                                    {pageItems[6] && (
                                       <NewsCard
                                          card={pageItems[6]}
                                          large={false}
                                          isLong={true}
                                          onRedirect={onRedirect}
                                       />
                                    )}
                                 </div>
                                 <div className="col-md-4">
                                    {pageItems[5] && (
                                       <NewsCard
                                          card={pageItems[5]}
                                          large={false}
                                          onRedirect={onRedirect}
                                       />
                                    )}
                                 </div>
                              </>
                           ) : (
                              <>
                                 <div className="col-md-4">
                                    {pageItems[5] && (
                                       <NewsCard
                                          card={pageItems[5]}
                                          large={false}
                                          onRedirect={onRedirect}
                                       />
                                    )}
                                 </div>
                                 <div className="col-md-8">
                                    {pageItems[6] && (
                                       <NewsCard
                                          card={pageItems[6]}
                                          large={false}
                                          isLong={true}
                                          onRedirect={onRedirect}
                                       />
                                    )}
                                 </div>
                              </>
                           )}
                        </div>

                        {/* Third Row */}
                        <div className="row mb-4 third-row">
                           {pageItems.slice(7, 10).map((card, idx) => (
                              <div
                                 className="col-md-4"
                                 key={`third-row-${pageIndex}-${idx}`}
                              >
                                 <NewsCard
                                    card={card}
                                    large={false}
                                    onRedirect={onRedirect}
                                 />
                              </div>
                           ))}
                        </div>
                     </React.Fragment>
                  )
               })}

               {newsData.length < totalCount && !loading && (
                  <div className="d-flex justify-content-center mt-4">
                     <button
                        className="btn learn-more"
                        onClick={handleLoadMore}
                     >
                        Load More
                     </button>
                  </div>
               )}

               <div className="d-flex gap-2 flex-wrap m-auto">
                  {(initialLoading || loading) && renderSkeletonLoader()}
               </div>

               {!initialLoading && newsData?.length === 0 && (
                  <div className="text-center py-5">
                     <h3>No news articles available right now</h3>
                     <p>
                        We couldn’t find any news articles at the moment. Please
                        check back later or try refreshing the page.
                     </p>
                  </div>
               )}
            </div>
         </section>
         <ContactUsForm />
      </>
   )
}

export default NewsRoomPage

const NewsCard = ({ card, large, onRedirect, isLong = false }) => (
   <div
      className={`card ${large ? 'large-card' : 'small-card'}`}
      onClick={() => onRedirect(card?.slug)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
         if (e.key === 'Enter') onRedirect(card?.slug)
      }}
   >
      <div className="image-wrapper object-fit-scale">
         <span className="news-label">{card.news_type}</span>
         <img
            src={card.image_url || '/assets/image/logo-new.png'}
            alt={card.rewritten_title}
            className={` ${
               card.image_url ? 'object-fit-cover' : 'object-fit-scale'
            }`}
            style={{ height: large ? '350px' : '180px', width: '100%' }}
            onError={(e) => {
               e.target.src = '/assets/image/logo-new.png'
            }}
         />
      </div>
      <div className="card-body d-flex flex-column">
         <h5 className="card-title" title={card.rewritten_title}>
            {card.rewritten_title}
         </h5>
         <p className="card-text">
            {card.re_content?.slice(0, large ? 700 : isLong ? 350 : 100)}...
         </p>
         <small className="news-meta">
            {card.news_from || 'Unknown'} |{' '}
            {new Date(card.created_at).toLocaleString('en-US', {
               month: 'short',
               day: '2-digit',
               year: 'numeric',
               hour: '2-digit',
               minute: '2-digit',
               hour12: false,
            })}
         </small>
      </div>
   </div>
)
